import { createFileRoute } from "@tanstack/react-router";

import { PublicSpecLatestRedirect } from "@/components/specifications/public-spec-latest-redirect";
import { PublicSpecLayout } from "@/components/specifications/public-spec-layout";
import { publicShareHead } from "@/lib/share-token";

// **The always-latest resolver** — `/public-spec/id/:specId?share_token=…`, a
// "Latest published" share link (#1022; ADR-0019). Top-level and outside
// `_authed/`: whoever holds the link reaches it with no session, and a
// signed-in visitor is a share visitor here (`system.md` §3.1, carve-out 3).
// Named in `routes-layout.unit.test.ts`'s public directory pins.
//
// It renders the public layout's spec face — Copy Link and Print over an empty
// page — while it asks, then replaces itself with the landing. The read runs
// on the client: a loader would skip the in-between frame the source shows.
export const Route = createFileRoute("/public-spec/id/$specId")({
  head: publicShareHead,
  component: PublicSpecLatestRoute,
});

function PublicSpecLatestRoute() {
  const { specId } = Route.useParams();
  return (
    <PublicSpecLayout share={{ specId }}>
      <PublicSpecLatestRedirect specId={specId} />
    </PublicSpecLayout>
  );
}
